import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { GENERATION_PORTAL_ID, GENERATION_PORTAL_ID_QA } from '../../accounts/accountsConstants';
import CompanionFooter from '../../interactiveEducation/components/CompanionFooter';

/* Temp hardcoded content id */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AI_GENERATED_CONTENT_ID_QA = 88707689;
export const AIGeneratedContentBanner = ({
  contentId,
  hubId
}) => {
  const expectedPortalId = enviro.isQa() ? GENERATION_PORTAL_ID_QA : GENERATION_PORTAL_ID;
  const matchesPortalId = hubId === expectedPortalId;

  // Temporarily, enable banner for existing QA content - until we get test content on QAportal 911635575
  const isQaTestContent = enviro.isQa() && contentId === AI_GENERATED_CONTENT_ID_QA;
  if (!matchesPortalId && !isQaTestContent) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      as: "h5",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: ArtificialIntelligenceIcon,
        paddingInlineEnd: "200",
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.aiContent.aiGeneratedBanner"
      })]
    }), /*#__PURE__*/_jsx(CompanionFooter, {
      contentType: "SHORT_FORM_CONTENT",
      flush: true,
      noBorder: true,
      primaryContentId: contentId,
      trackingAction: "AI_GENERATED_CONTENT_FEEDBACK"
    })]
  });
};
export default AIGeneratedContentBanner;